export default __webpack_public_path__ + "assets/chelem.e7037313.jpg";